import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import MtechEle from './MtechEle'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission"/>
            <MtechEle />
        </>
    )
}

export default Main